import { render, staticRenderFns } from "./UserGroupDeleteModal.vue?vue&type=template&id=00866b80&scoped=true&"
import script from "./UserGroupDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./UserGroupDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00866b80",
  null
  
)

export default component.exports